<template>
  <div class="s-header">
    <div class="left">{{title}}</div>
    <router-link v-if="!!linkto" target="_blank" :to="linkto" class="right">MORE <span></span></router-link>
  </div>
</template>

<script>
export default {
  name: 'SHeader',
  props: {
    linkto: {
      type: String,
      default: '#'
    },
    title: {
      type: String,
      default: '推荐'
    }
  }
}
</script>

<style lang='less' scoped>
  .s-header {
    width: 100%;
    height: 24px;
    line-height: 24px;
    border-left: 4px solid #dc2d4b;
    margin-bottom: 20px;
    .left {
      display: inline-block;
      width: 50px;
      font-size: 24px;
      height: 24px;
      font-weight: bold;
      padding-left: 30px;
    }
    .right {
      display: inline-block;
      width: calc(100% - 80px);
      text-align: right;
      font-size: 16px;
      color: #666;
      vertical-align: text-bottom;
      span {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-right: 2px solid #666;
        border-top: 2px solid #666;
        transform: translateX(-2px) rotate(45deg);
      }
    }
  }
</style>
